import { useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { metaPixelService } from '../lib/metaPixel';

export const useMetaPixel = () => {
  const location = useLocation();

  // Track page views on route changes
  useEffect(() => {
    if (metaPixelService.isPixelEnabled()) {
      metaPixelService.trackPageView(location.pathname + location.search);
    }
  }, [location]);

  const trackEvent = useCallback((eventName: string, parameters?: Record<string, any>, value?: number, currency?: string) => {
    if (metaPixelService.isPixelEnabled()) {
      metaPixelService.trackEvent({
        eventName,
        parameters,
        value,
        currency
      });
    }
  }, []);

  const trackLead = useCallback((value?: number, currency?: string) => {
    if (metaPixelService.isPixelEnabled()) {
      metaPixelService.trackLead(value, currency);
    }
  }, []);

  const trackSignUp = useCallback((value?: number, currency?: string) => {
    if (metaPixelService.isPixelEnabled()) {
      metaPixelService.trackSignUp(value, currency);
    }
  }, []);

  const trackStartTrial = useCallback((value?: number, currency?: string) => {
    if (metaPixelService.isPixelEnabled()) {
      metaPixelService.trackStartTrial(value, currency);
    }
  }, []);

  const trackButtonClick = useCallback((buttonName: string, location: string) => {
    if (metaPixelService.isPixelEnabled()) {
      metaPixelService.trackButtonClick(buttonName, location);
    }
  }, []);

  const trackFormSubmission = useCallback((formName: string, success: boolean) => {
    if (metaPixelService.isPixelEnabled()) {
      metaPixelService.trackFormSubmission(formName, success);
    }
  }, []);

  const trackVideoInteraction = useCallback((action: 'play' | 'pause' | 'complete', videoName: string) => {
    if (metaPixelService.isPixelEnabled()) {
      metaPixelService.trackVideoInteraction(action, videoName);
    }
  }, []);

  const trackScrollDepth = useCallback((depth: number) => {
    if (metaPixelService.isPixelEnabled()) {
      metaPixelService.trackScrollDepth(depth);
    }
  }, []);

  const trackTimeOnPage = useCallback((seconds: number) => {
    if (metaPixelService.isPixelEnabled()) {
      metaPixelService.trackTimeOnPage(seconds);
    }
  }, []);

  const trackPricingView = useCallback(() => {
    if (metaPixelService.isPixelEnabled()) {
      metaPixelService.trackPricingView();
    }
  }, []);

  const trackAmbassadorInterest = useCallback(() => {
    if (metaPixelService.isPixelEnabled()) {
      metaPixelService.trackAmbassadorInterest();
    }
  }, []);

  const isEnabled = useCallback(() => {
    return metaPixelService.isPixelEnabled();
  }, []);

  return {
    trackEvent,
    trackLead,
    trackSignUp,
    trackStartTrial,
    trackButtonClick,
    trackFormSubmission,
    trackVideoInteraction,
    trackScrollDepth,
    trackTimeOnPage,
    trackPricingView,
    trackAmbassadorInterest,
    isEnabled
  };
}; 